import { IConfigContextProps } from '../contexts/ConfigContext';
import {
    DisabledComponentsTypes,
    DisabledFunctionsTypes,
} from '../contexts/ConfigContext/interfaces';
import { IFrontendContext } from '../contexts/FrontendContext';

/**  General conditional checkers  **/
export const shouldAllowFunction = (
    functionName: DisabledFunctionsTypes,
    configContext: IConfigContextProps,
) => !configContext?.disabledFunctions?.includes(functionName);

export const shouldAllowComponent = (
    componentName: DisabledComponentsTypes,
    configContext: IConfigContextProps,
) => !configContext?.disabledComponents?.includes(componentName);

export const shouldAllowForgotPassword = (
    configContext: IConfigContextProps,
    frontendContext: IFrontendContext,
) =>
    frontendContext.state.showForgotPassword &&
    !configContext.isCheckoutAuthenticationFlow &&
    !configContext?.featureFlags?.launchPasswordlessLogin;

/**  Individual easier to use helper conditional functions  **/
export const shouldAllowLookup = (configContext: IConfigContextProps) =>
    shouldAllowFunction(DisabledFunctionsTypes.lookup, configContext);

/**  Individual easier to use helper conditional components  **/
export const shouldAllowHeader = (configContext: IConfigContextProps) =>
    shouldAllowComponent(DisabledComponentsTypes.header, configContext);

export const shouldAllowNotifications = (configContext: IConfigContextProps) =>
    shouldAllowComponent(DisabledComponentsTypes.notifications, configContext);
